/**
 * vue-query 클라이언트 — 단일 인스턴스 SSoT.
 *
 * main.ts(엔트리)가 아닌 독립 모듈에 둔다 — 컴포넌트 밖(스토어·인터셉터)에서 정적 import 로 캐시를
 * 직접 정리할 수 있게 하면서 엔트리와의 순환 의존(main→router→store→main)을 피한다.
 * 특히 로그아웃 시 사용자별 캐시를 비워 다음 사용자에게 누출되지 않도록 한다(stores/auth.ts logout()).
 */
import { QueryClient } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
